import { Box, alpha } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Carousel } from 'views/rebranded-module/common/components';

const StyledBox = styled(Box)(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(14, 0),
  background: `linear-gradient(180deg, ${theme.palette.background.primary}) 0%, rgba(17, 17, 17, 0.00) 100%), ${theme.palette.background.primary})`,
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(8, 0),
  },
  '& .OFSBGPattern': {
    position: 'absolute',
    top: 0,
    width: '100%',
    height: theme.typography.pxToRem(205),
    zIndex: 1,
    maskImage: `linear-gradient(
        to bottom,
         ${alpha(theme.palette.common.black, 0.6)} 50%,
         ${alpha(theme.palette.common.black, 0.01)} 100%
      )`,
  },
  '& .OFSTitleContainer': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(8),
    [theme.breakpoints.down('lg')]: {
      gap: theme.spacing(3),
      flexDirection: 'column',
      alignItems: 'flex-start',
      marginBottom: theme.spacing(4),
    },
  },
  '& .OFSContent':{
      position: 'relative',
      zIndex: 2,
  },
    '& .OFSListItem': {
    marginBottom: theme.spacing(1),
    display: 'flex',
    alignItems: 'flex-start',
    padding: 0,
  },
  '& .OFSIcon': {
    width: theme.spacing(3),
    height: theme.spacing(3),
    marginRight: theme.spacing(1),
    flex: '0 0 auto',
  },
  '& .OFSBikeCard': {
    height: '100%',
  },
  '& .OFSImgContainer': {
    height: theme.typography.pxToRem(200),
    backgroundColor: theme.palette.common.white,
 
  },
  '& .OFSSlider':{
    position: 'relative',
  },
}));

export const StyledCarousel = styled(Carousel)(({ theme }) => ({
 '& .CArrow.CArrowRight': {
    right: theme.spacing(-1),
},
'& .CArrow.CArrowLeft': {
    left: theme.spacing(7),
}
}));

export default StyledBox;
